module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedDecade !== 0) ? _c('nav', {
    staticClass: "decade-nav-mobile"
  }, [(_vm.selectedDecade !== _vm.decades[0]) ? _c('div', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleDecadeSelect(_vm.selectedDecade - 10)
      }
    }
  }, [_vm._v(_vm._s((_vm.selectedDecade - 10) + 's'))])]) : _vm._e(), _vm._v(" "), (_vm.selectedDecade !== _vm.decades[_vm.decades.length - 1]) ? _c('div', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleDecadeSelect(_vm.selectedDecade + 10)
      }
    }
  }, [_vm._v(_vm._s((_vm.selectedDecade + 10) + 's'))])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-345fe5d3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345fe5d3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./timeline/js/components/DecadeNavMobile.vue
// module id = 52
// module chunks = 0